<template>
    <div class="row interment-details-content">
        <div class="col-12">
            <div class="row">
                <div class="col-12 col-sm-6">
                    <div class="form-group">
                        <MaterialInput
                            :readonly="readonlyForm"
                            :disabled="readonlyForm"
                            class="city-form-group city-bg"
                            id="input-interment_number"
                            type="number"
                            name="interment_number"
                            v-model.trim="form.interment_number"
                            v-validate="rulesField('interment_number', {integer: true, min_value:0})"
                            :data-vv-scope="vScope"
                            :inputClasses="[{'is-invalid': fnHasError('interment_number', vScope) }]"
                            :error="fnFirstError('interment_number', vScope)">
                            {{ $t(`${modelTranslateID}.interment_number`) }}
                        </MaterialInput>
                    </div>
                </div>
                <div class="col-12 col-sm-6">
                    <div class="form-group">
                        <MaterialInput
                            :readonly="readonlyForm"
                            :disabled="readonlyForm"
                            class="city-form-group city-bg"
                            id="input-interment_depth"
                            type="number"
                            name="interment_depth"
                            v-model.trim="form.interment_depth"
                            v-validate="rulesField('interment_depth', {required: true, decimal: true, min_value:0})"
                            :data-vv-scope="vScope"
                            :inputClasses="[{'is-invalid': fnHasError('interment_depth', vScope) }]"
                            :error="fnFirstError('interment_depth', vScope)">
                            {{ $t(`${modelTranslateID}.interment_depth`) }}
                        </MaterialInput>
                    </div>
                </div>
                <div class="col-12 col-sm-6">
                    <div class="form-group">
                        <MaterialDatePicker
                            :disabled="readonlyForm"
                            class="city-form-group city-bg"
                            id="input-interment_at"
                            name="interment_at"
                            v-model.trim="form.interment_at"
                            :dateFormat="labelDateFormat"
                            :databaseDateFormat="dateFormat"
                            v-validate="rulesField('interment_at', {dateAfter: [form?.entity?.death_at, true, $t(`${modelTranslateID}.entity.death_at`)]})"
                            :data-vv-scope="vScope"
                            :inputClasses="[{'is-invalid': fnHasError('interment_at', vScope) }]"
                            :error="fnFirstError('interment_at', vScope)">
                            {{ $t(`${modelTranslateID}.interment_at`) }}
                        </MaterialDatePicker>
                    </div>
                </div>
                <div class="col-12 col-sm-6">
                    <div class="form-group">
                        <MaterialSelect
                            :disabled="readonlyForm"
                            class="city-form-group city-bg"
                            id="input-interment_type"
                            name="interment_type"
                            label="name"
                            v-model.trim="form.interment_type_id"
                            :options="interment_types"
                            v-validate="rulesField('interment_type_id')"
                            :data-vv-scope="vScope"
                            :inputClasses="[{'is-invalid': fnHasError('interment_type', vScope)}]"
                            :error="fnFirstError('interment_type', vScope)">
                            {{ $t(`${modelTranslateID}.interment_type`) }}
                        </MaterialSelect>
                    </div>
                </div>
                <div class="col-12 col-sm-6">
                    <div class="form-group">
                        <MaterialSelect
                            :disabled="readonlyForm"
                            class="city-form-group city-bg"
                            id="input-container_type"
                            name="container_type"
                            label="name"
                            v-model.trim="form.container_type_id"
                            :options="container_types"
                            v-validate="rulesField('container_type_id')"
                            :data-vv-scope="vScope"
                            :inputClasses="[{'is-invalid': fnHasError('container_type', vScope)}]"
                            :error="fnFirstError('container_type', vScope)">
                            {{ $t(`${modelTranslateID}.container_type`) }}
                        </MaterialSelect>
                    </div>
                </div>
                <div class="col-12 col-sm-6">
                    <div class="form-group">
                        <MaterialInput
                            :readonly="readonlyForm"
                            :disabled="readonlyForm"
                            class="city-form-group city-bg"
                            id="input-container_dimensions"
                            name="container_dimensions"
                            v-model.trim="form.container_dimensions"
                            v-validate="rulesField('container_dimensions')"
                            :data-vv-scope="vScope"
                            :inputClasses="[{'is-invalid': fnHasError('container_dimensions', vScope) }]"
                            :error="fnFirstError('container_dimensions', vScope)">
                            {{ $t(`${modelTranslateID}.container_dimensions`) }}
                        </MaterialInput>
                    </div>
                </div>

                <div class="col-12 col-sm-6">
                    <div class="form-group">
                        <MaterialInput
                            :readonly="readonlyForm"
                            :disabled="readonlyForm"
                            class="city-form-group city-bg"
                            id="input-fee"
                            name="fee"
                            type="number"
                            v-model.trim="form.fee"
                            :step="stepPriceDecimalPlaces"
                            v-validate="rulesField('fee', {decimal: priceDecimalPlaces, min_value:0})"
                            :data-vv-scope="vScope"
                            :inputClasses="[{'is-invalid': fnHasError('fee', vScope) }]"
                            :error="fnFirstError('fee', vScope)">
                            {{ $t(`${modelTranslateID}.fee`) }}
                            <template #grpAppend>
                                <span class="input-group-text">{{ currency.symbol }}</span>
                            </template>
                        </MaterialInput>
                    </div>
                </div>
                <div class="col-12 col-sm-6">
                    <div class="form-group">
                        <MaterialDatePicker
                            :disabled="readonlyForm"
                            class="city-form-group city-bg"
                            id="input-payment_at"
                            name="payment_at"
                            v-model.trim="form.payment_at"
                            :dateFormat="labelDateFormat"
                            :databaseDateFormat="dateFormat"
                            v-validate="''"
                            :data-vv-scope="vScope"
                            :inputClasses="[{'is-invalid': fnHasError('payment_at', vScope) }]"
                            :error="fnFirstError('payment_at', vScope)">
                            {{ $t(`${modelTranslateID}.payment_at`) }}
                        </MaterialDatePicker>
                    </div>
                </div>

                <div class="col-12 col-sm-12">
                    <div class="form-group">
                        <MaterialTextarea
                            :readonly="readonlyForm"
                            :disabled="readonlyForm"
                            class="city-form-group city-bg"
                            :id="`input-ceremony`"
                            :name="`ceremony`"
                            :rows="3"
                            v-model.trim="form.ceremony"
                            v-validate="rulesField('ceremony')"
                            :data-vv-scope="vScope"
                            :inputClasses="[{'is-invalid': fnHasError(`ceremony`, vScope) }]"
                            :error="fnFirstError(`ceremony`, vScope)">
                            {{ $t(`${modelTranslateID}.ceremony`) }}
                        </MaterialTextarea>
                    </div>
                </div>
                <div class="col-12 col-sm-12">
                    <div class="form-group">
                        <MaterialTextarea
                            :readonly="readonlyForm"
                            :disabled="readonlyForm"
                            class="city-form-group city-bg"
                            :id="`input-obs`"
                            :name="`obs`"
                            :rows="3"
                            v-model.trim="form.obs"
                            v-validate="rulesField('obs')"
                            :data-vv-scope="vScope"
                            :inputClasses="[{'is-invalid': fnHasError(`obs`, vScope) }]"
                            :error="fnFirstError(`obs`, vScope)">
                            {{ $t(`${modelTranslateID}.obs`) }}
                        </MaterialTextarea>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
import FormElementMixin from "../mixins/FormElementMixin";

export default {
    mixins: [
        FormElementMixin
    ],
    components: {
        MaterialDatePicker: () => import(/* webpackChunkName: "datepicker" */ '@/components/form/MaterialDatePicker'),
    },
    props: {
        interment_types: {
            type: Array,
            default: () => {return [];},
        },
        container_types: {
            type: Array,
            default: () => {return [];},
        },
    },
    data() {
        return {
            // id: null,
            // fee_paid: null,
            // ceremony: null,
        }
    },
    computed: {

    },
    methods: {

    }
}
</script>

<style lang="scss" scoped>

</style>